import LandingSimple from './LandingSimple.js'
import Timeline from './Timeline.js';
import Header from './Header.js';
import Projects from './SimpleProjectList.js';
import '../stylesheets/Home.css';

const Home = (props) => {
    return <>
        <div className="bg"
            style={
                // {backgroundImage: `url('/images/funko_devan.png')`}
                {backgroundColor: 'white'}
            }
        >   
            <Header {...props} />
            <div className="scroller">

                <LandingSimple/>
                <Projects {...props}/>
                <Timeline />
            </div>
        </div>
    </>;
}

export default Home;